import manifest from "./character-manifest.json";

export const characterManifest = manifest;
export const characterAssets = manifest.characters;

export type CharacterId = keyof typeof characterAssets;
export type CharacterAnimation = keyof typeof characterAssets[CharacterId]["animations"];
export type CharacterPose = CharacterAnimation | "jump" | "hide";
export const characterIds = Object.keys(characterAssets) as CharacterId[];

export function characterFor(value: string | null | undefined): CharacterId {
  return value && Object.hasOwn(characterAssets, value) ? value as CharacterId : "cursor_runner";
}

export function characterAnimationKey(id: CharacterId, pose: CharacterPose): string {
  const animation = pose === "jump" ? "jump_start" : pose === "hide" ? "crouch_hide" : pose;
  const fallback = characterAssets[id].animations[animation]?.fallback;
  return `${id}:${fallback ?? animation}`;
}
